import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {AnnualFeeService} from '../../services/annual-fee.service';
import {CompanyService} from '../services/company.service';
import {RoleService} from '../../services/role.service';
import {toDateString} from '../../providers/app-date-adapter';
import {AnnualFee} from '../../dto/annualFee';
import {ContentRowField} from '../../shared/content-row/content-row.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MatButtonToggle} from '@angular/material/button-toggle';
import {Company} from '../../dto/company';
import {CardStatusEnum} from "../../dto/card-status-enum";
import {Product} from "../../dto/product";
import {forkJoin} from "rxjs";
import {ProductService} from "../services/product.service";
import {ActivatedRoute, Params} from "@angular/router";

@Component({
  selector: 'app-annual-fees',
  templateUrl: './annual-fees.component.html',
  styleUrls: ['./annual-fees.component.css']
})
export class AnnualFeesComponent implements OnInit, AfterViewInit {

  isLoading = false;
  companies: Company[] = [];

  public dateFiltersList = [
    { name: 'creation', header: 'Creation date' },
    { name: 'due', header: 'Due date' },
    { name: 'paid', header: 'Paid date' },
  ];
  from: string = "";


  constructor(
    private annualFeesService: AnnualFeeService,
    private companyService: CompanyService,
    private productService: ProductService,
    private roleService: RoleService,
    private route: ActivatedRoute,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;
  @ViewChild(MatButtonToggle, { static: false }) allButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.annualFeesService);

  columns = [
    { columnDef: 'creationDate', header: 'Creation date', cell: row => `${toDateString(row.creationDate) || ''}` },
    { columnDef: 'dueDate', header: 'Due date', cell: row => `${toDateString(row.dueDate) || ''}` },
    { columnDef: 'paidDate', header: 'Paid date', cell: row => `${toDateString(row.paidDate) || ''}` },
    { columnDef: 'customer', header: 'Customer', cell: row => `${row.card.customer.firstName} ${row.card.customer.lastName}` },
    { columnDef: 'phoneNumber', header: 'Phone', cell: row => `${row.card.customer.phone}` } ,
    { columnDef: 'token', header: 'Token', cell: row => `${row.card.token}` } ,
    { columnDef: 'amount', header: 'Amount', cell: row => `${row.amount}` } ,
    { columnDef: 'amountPaid', header: 'Paid', cell: row => `${row.amountPaid}` } ,



  ] as ContentRowField<AnnualFee>[];

  checkAllButton() {
    try {
      this.allButton.checked = true;


    } catch (e) {
      console.log(e);
    }
  }

  getViewLink = (item: AnnualFee): string => item.id.toString();

  getEditLink = (item: AnnualFee): string => item.id.toString() + '/edit';
  public dialogRemoveText = 'Removing annual fees';


  ngOnInit(): void {

    this.loadCompanies();
  }

  ngAfterViewInit(): void {

    this.route.queryParams.subscribe((params: Params) => {
      let statusFilter = params['statusFilter'];
      let from = params['from'];

      this.from = from;

      console.log(statusFilter);
      if (statusFilter) {
        this.table.filters.additionalValue1 = statusFilter;
        setTimeout(() => this.table.applyFilter(), 1000);

      }

    });

  }



  clearFilter() {
    this.table.clearFilter();
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  editEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  deleteEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner']);
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  triggerSearch() {
    this.onSearch();
  }
  onSearch(ignore: boolean = false) {
    if ( this.isLoading ) {
      return;
    }
    if (ignore) {
      return;
    }
    this.table.applyFilter();
  }


  loadCompanies() {
    this.companyService.getAll().subscribe(result => {
      this.companies = result.data;
      this.onCompanyChange(null);
    });
  }


  protected readonly cardStatus = CardStatusEnum;
  productsToShow: Product[] = [];

  onCompanyChange($event: any) {

    if (!this.table.filters.companiesFilter || this.table.filters.companiesFilter.length == 0) {
      this.productsToShow = [];
      return;
    }

    let products = [];

    const companyIds = this.table.filters.companiesFilter.map(value => parseInt(value));
    const futures = [];

    companyIds.forEach(
      value => {
        futures.push(this.productService.getForCompany(value, true));
      }
    );

    forkJoin(
      ...futures,
    ).subscribe(([...pss]) => {

      pss.forEach(ps => products = products.concat(ps));
      this.productsToShow = products;
    });


  }


}
